import { jsxs as o, jsx as C } from "react/jsx-runtime";
const i = ({ className: t, width: r = "24", height: e = "24" }) => /* @__PURE__ */ o(
  "svg",
  {
    className: t,
    width: r,
    height: e,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    children: [
      /* @__PURE__ */ C(
        "rect",
        {
          x: "2.25",
          y: "2.25",
          width: "19.5",
          height: "19.5",
          rx: "9.75",
          stroke: "#C6CACD",
          strokeWidth: "1.5"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M10.9953 14.0577V13.948C11.0016 13.3662 11.0585 12.9037 11.1659 12.5603C11.2733 12.2138 11.4281 11.9356 11.6303 11.7258C11.8325 11.5128 12.0774 11.3173 12.3649 11.1392C12.5545 11.0184 12.7251 10.8849 12.8768 10.7387C13.0284 10.5924 13.1485 10.4271 13.237 10.2427C13.3286 10.0552 13.3744 9.84692 13.3744 9.61803C13.3744 9.35416 13.3112 9.12526 13.1848 8.93133C13.0616 8.7374 12.8957 8.58798 12.6872 8.48307C12.4818 8.37498 12.2528 8.32093 12 8.32093C11.7694 8.32093 11.5482 8.37021 11.3365 8.46876C11.128 8.56732 10.9542 8.71833 10.8152 8.92179C10.6793 9.12526 10.6019 9.38436 10.5829 9.69909H9C9.02212 9.11095 9.16904 8.6166 9.44076 8.21602C9.71248 7.81227 10.0711 7.50866 10.5166 7.3052C10.9652 7.10173 11.4613 7 12.0047 7C12.5987 7 13.1201 7.10809 13.5687 7.32427C14.0205 7.53728 14.3712 7.83929 14.6209 8.23033C14.8736 8.62136 15 9.08234 15 9.61326C15 9.9725 14.9431 10.2952 14.8294 10.5813C14.7156 10.8674 14.5545 11.1218 14.346 11.3443C14.1374 11.5637 13.8894 11.7608 13.6019 11.9356C13.3397 12.0978 13.1264 12.2678 12.9621 12.4459C12.7978 12.6207 12.6761 12.8274 12.5972 13.0658C12.5213 13.3011 12.4818 13.5951 12.4787 13.948V14.0577H10.9953ZM11.7773 17C11.5024 17 11.2654 16.9014 11.0664 16.7043C10.8705 16.5072 10.7725 16.2704 10.7725 15.9938C10.7725 15.7172 10.8705 15.4804 11.0664 15.2833C11.2654 15.0862 11.5024 14.9876 11.7773 14.9876C12.0458 14.9876 12.2796 15.0862 12.4787 15.2833C12.6777 15.4804 12.7773 15.7172 12.7773 15.9938C12.7773 16.1782 12.7299 16.3467 12.6351 16.4993C12.5434 16.6519 12.4218 16.7743 12.2701 16.8665C12.1216 16.9555 11.9573 17 11.7773 17Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  i as default
};
